import { IStateMallBrand } from '../../entity/StateEntity';
import { MALL_BRAND_STATUS_RELOAD, MALL_BRAND_STATUS_SUCCESS, MALL_BRAND_STATUS_REQUEST, MALL_BRAND_STATUS_FAILURE } from 'src/constants/ActionTypes';

const initialState: IStateMallBrand = {
  reload: true,
  isFetching: false,
  type: MALL_BRAND_STATUS_RELOAD,
  brandList: [],
};

export const mallBrandState = (state: IStateMallBrand = initialState, action: IStateMallBrand): IStateMallBrand => {
  switch (action.type) {
    case MALL_BRAND_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        brandList: action.brandList,
      });

    case MALL_BRAND_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        brandList: [],
      });

    case MALL_BRAND_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        brandList: [],
      });

    case MALL_BRAND_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        brandList: [],
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/mallBrandState.ts